var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.94 4.354a1.5 1.5 0 0 1 2.12 0l1.415 1.414a1.5 1.5 0 0 1 0 2.121l-9.664 9.664a.495.495 0 0 1-.105.08l-3.417 1.953c-1.326.757-2.804-.72-2.046-2.047l1.952-3.416a.499.499 0 0 1 .08-.106l9.664-9.663Zm1.414.707a.5.5 0 0 0-.708 0l-2.18 2.18 2.121 2.121 2.18-2.18a.5.5 0 0 0 0-.707L18.355 5.06Zm-1.474 5.008-2.12-2.121-6.424 6.423 2.121 2.121 6.423-6.423Zm-7.239 7.02-1.903-1.902-1.627 2.848c-.252.442.24.935.682.682l2.848-1.627Z",
    fill: "#818C96"
  })));
};

export default SvgEdit;